import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetLastMonthPointRankingResponseDataDto } from 'viewup-api/v2';

// 반환 타입을 명시한다 — SDK 생성 `.d.ts`가 axios `AxiosResponse<T, D>`(2개 타입 인자)에
// 4개 인자(`AxiosResponse<T, any, {}, any>`)를 넘겨 malformed 상태인데, `skipLibCheck: true`가
// 그 선언 파일 내부 오류를 검사하지 않고 넘어가면서 사용처(`response`)가 조용히 `any`로
// 무너진다 — annotation 없인 tsc가 `rank.id`처럼 존재하지 않는 필드 접근도 못 잡는다.
export const getRankingMonth = async (): Promise<GetLastMonthPointRankingResponseDataDto[]> => {
  const response = await serviceApi.point.getLastMonthPointRanking(withServiceRequestDefaults());

  return response.data.data;
};
